import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'horario-tag',
    template: require('./horario.component.html')
})
export class HorarioComponent implements OnInit {
    constructor() { }

    ngOnInit() { }
} 


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/angular2-router-loader/src!./app/admin/ivr/horario.component.ts